<template>
    <div class="header">
        <!-- 左侧logo -->
        <h1 class="logo-h1">
            <div style="cursor: pointer" @click="reloadPage('/')"  class="logo-f">
                <img class="logo-img" :src="require('@/assets/images/logo_head.png')" alt="人人动画网">
            </div>
        </h1>
        <!-- 右侧按钮 -->
        <div class="rig-btns" v-if="isLogin">
            <div class="btn only-phone-show">
              <img class="icon" :src="require('@/assets/images/side_icon_01.png')" @click="dialogQRCodes = true" alt="">
            </div>
            <!-- <a href="http://i.renrendonghua.com/#/works/upload" class="btn" title="上传作品">
                <img class="icon" :src="require('@/assets/images/head_btn_02.png')" alt="">
            </a> -->
            <el-dropdown class="upload-art only-pc-show" @mouseenter.native="hideTip" v-if="plateType !=0">
                <a href="javascript:;" class="btn upload-btn">
                    <img class="icon" :src="require('@/assets/images/head_btn_02.png')" alt="">
                    <transition leave-active-class="animated fadeOut">
                        <div class="upload-tips" v-if="tipShow">马上发布一篇作品吧！</div>
                    </transition>
                </a>
                <!--板块 ： nv：动画短片 1 nt：传统文化 2 na：动画制作 3  plate-->
                <el-dropdown-menu slot="dropdown">
                    <a :href="'http://i.renrendonghua.com/works/upload?productionForm=1&belongSection='+plateType" target="_blank" v-if="plateType == '3'"><el-dropdown-item>发图片</el-dropdown-item></a>
                    <a :href="'http://i.renrendonghua.com/works/upload?productionForm=2&belongSection='+plateType" target="_blank" v-if="plateType == '1' || plateType == '3'"><el-dropdown-item>发视频</el-dropdown-item></a>
                    <a :href="'http://i.renrendonghua.com/works/upload?productionForm=3&belongSection='+plateType" target="_blank" v-if="plateType == '2' "><el-dropdown-item>发文章</el-dropdown-item></a>
                    <router-link :to="'/askque?belongSection='+plateType"  v-if="plateType == '3'" target="_blank"><el-dropdown-item>发问答</el-dropdown-item></router-link>
                    <!-- <router-link to="/create/works"><el-dropdown-item>发布作品</el-dropdown-item></router-link>
                    <router-link to="/create/column"><el-dropdown-item>发布专栏</el-dropdown-item></router-link>
                    <router-link to="/create/ques"><el-dropdown-item>发布问答</el-dropdown-item></router-link>
                    <router-link to="/create/source"><el-dropdown-item>发布素材</el-dropdown-item></router-link> -->
                </el-dropdown-menu>
            </el-dropdown>
            <a href="javascript:;" class="btn messages-btn only-pc-show" v-if="plateType !=0">
                <img class="icon" :src="require('@/assets/images/head_btn_03.png')" alt="">
                <span class="mess-count" v-if="unReadCount>0">{{unReadCount}}</span>
                <div class="messages-show">
                    <ul class="tabs-tit">
                        <li :class="{'active': messageIndex === 0 ? true : false}" @click="messageEvent(0)">通知</li>
                        <li :class="{'active': messageIndex === 1 ? true : false}" @click="messageEvent(1)">消息</li>
                    </ul>
                    <div class="tabs-content">
                        <ul class="cont-item" v-if="messageIndex === 0">
                            <li class="m-item" v-for="(item, index) in unReadNotify" :key="index">
                                <span v-if="(item.notifyType ==11 && item.objectType ==3) ||(item.notifyType ==12 && item.objectType ==1)||(item.notifyType ==13 && item.objectType ==2)">
                                    您关注的</span>
                                <router-link target="_blank" :to="{path:'/home', query: {userId:item.notifier}}">{{item.notifierName}}</router-link>

                                <span v-if="item.notifyType ==6">关注了您</span>
                                <span v-else-if="item.notifyType ==4 && item.objectType ==1">评论了您的作品<a target="_blank" :href="'http://www.renrendonghua.com/worksdetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>
                                <span v-else-if="item.notifyType ==4 && item.objectType ==2">评论了您的文章<a target="_blank" :href="'http://www.renrendonghua.com/column/themedetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>

                                <span v-else-if="item.notifyType ==4 && item.objectType ==9 && item.notifyContent=='作品'" >评论了您转发的作品<a target="_blank" :href="'http://www.renrendonghua.com/worksdetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>
                                <span v-else-if="item.notifyType ==4 && item.objectType ==9 && item.notifyContent=='文章'" >评论了您转发的文章<a target="_blank" :href="'http://www.renrendonghua.com/column/themedetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>
                                <span v-else-if="item.notifyType ==4 && item.objectType ==10 && item.notifyContent=='作品'" >评论了您收藏的作品<a target="_blank" :href="'http://www.renrendonghua.com/worksdetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>
                                <span v-else-if="item.notifyType ==4 && item.objectType ==10 && item.notifyContent=='文章'" >评论了您收藏的文章<a target="_blank" :href="'http://www.renrendonghua.com/column/themedetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>
                                <span v-else-if="item.notifyType ==4 && item.objectType ==11 && item.notifyContent=='作品'" >评论了您评论的作品<a target="_blank" :href="'http://www.renrendonghua.com/worksdetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>
                                <span v-else-if="item.notifyType ==4 && item.objectType ==11 && item.notifyContent=='文章'" >评论了您评论的文章<a target="_blank" :href="'http://www.renrendonghua.com/column/themedetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>

                                <span v-else-if="item.notifyType ==5 && item.objectType ==1">收藏了您的作品<a target="_blank" :href="'http://www.renrendonghua.com/worksdetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>
                                <span v-else-if="item.notifyType ==5 && item.objectType ==2">收藏了您的文章<a target="_blank" :href="'http://www.renrendonghua.com/column/themedetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>
                                <span v-else-if="item.notifyType ==5 && item.notifyContent=='作品'">收藏了您的作品<a target="_blank" :href="'http://www.renrendonghua.com/worksdetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>
                                <span v-else-if="item.notifyType ==5 && item.notifyContent=='文章'">收藏了您的文章<a target="_blank" :href="'http://www.renrendonghua.com/column/themedetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>


                                <span v-else-if="item.notifyType ==7 && item.objectType ==1">点赞了您的作品<a target="_blank" :href="'http://www.renrendonghua.com/worksdetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>
                                <span v-else-if="item.notifyType ==7 && item.objectType ==2">点赞了您的文章<a target="_blank" :href="'http://www.renrendonghua.com/column/themedetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>

                                <span v-else-if="item.notifyType ==7 && item.objectType ==9 && item.notifyContent=='作品'" >点赞了您转发的作品<a target="_blank" :href="'http://www.renrendonghua.com/worksdetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>
                                <span v-else-if="item.notifyType ==7 && item.objectType ==9 && item.notifyContent=='文章'" >点赞了您转发的文章<a target="_blank" :href="'http://www.renrendonghua.com/column/themedetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>
                                <span v-else-if="item.notifyType ==7 && item.objectType ==10 && item.notifyContent=='作品'" >点赞了您收藏的作品<a target="_blank" :href="'http://www.renrendonghua.com/worksdetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>
                                <span v-else-if="item.notifyType ==7 && item.objectType ==10 && item.notifyContent=='文章'" >点赞了您收藏的文章<a target="_blank" :href="'http://www.renrendonghua.com/column/themedetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>
                                <span v-else-if="item.notifyType ==7 && item.objectType ==11 && item.notifyContent=='作品'" >点赞了您评论的作品<a target="_blank" :href="'http://www.renrendonghua.com/worksdetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>
                                <span v-else-if="item.notifyType ==7 && item.objectType ==11 && item.notifyContent=='文章'" >点赞了您评论的文章<a target="_blank" :href="'http://www.renrendonghua.com/column/themedetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>

                                <span v-else-if="item.notifyType ==8 && item.objectType ==1">转发了您的作品<a target="_blank" :href="'http://www.renrendonghua.com/worksdetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>
                                <span v-else-if="item.notifyType ==8 && item.objectType ==2">转发了您的文章<a target="_blank" :href="'http://www.renrendonghua.com/column/themedetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>

                                <span v-else-if="item.notifyType ==8  && item.notifyContent=='作品'" >转发了您的作品<a target="_blank" :href="'http://www.renrendonghua.com/worksdetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>
                                <span v-else-if="item.notifyType ==8 && item.notifyContent=='文章'" >转发了您的文章<a target="_blank" :href="'http://www.renrendonghua.com/column/themedetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>

                                <span v-else-if="item.notifyType ==9 && item.objectType ==1">在(<a target="_blank" :href="'http://www.renrendonghua.com/worksdetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a>)的评论中@了您</span>
                                <span v-else-if="item.notifyType ==9 && item.objectType ==2">在(<a target="_blank" :href="'http://www.renrendonghua.com/column/themedetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a>)的评论中@了您</span>
                                <span v-else-if="item.notifyType ==9 && item.objectType ==6">在(<a target="_blank" :href="'http://www.renrendonghua.com/modeldetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a>)的评论中@了您</span>
                                <span v-else-if="item.notifyType ==9 && item.objectType ==7">在(<a target="_blank" :href="'http://www.renrendonghua.com/videodetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a>)的评论中@了您</span>
                                <span v-else-if="item.notifyType ==9 && item.objectType ==77">在(<a target="_blank" :href="'http://www.renrendonghua.com/livedetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a>)的评论中@了您</span>
                                <span v-else-if="item.notifyType ==9 && item.objectType ==8">在(<a target="_blank" :href="'http://www.renrendonghua.com/videoduo?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a>)的评论中@了您</span>

                                <span v-else-if="item.notifyType ==9 && item.objectType ==9">在(<a target="_blank" :href="'http://www.renrendonghua.com/quedetail?id='+item.objectId">{{item.objectName}}</a>)的评论中@了您</span>

                                <span v-else-if="item.notifyType ==9 && item.objectType ==12">在(<a target="_blank" :href="'http://www.renrendonghua.com/filmdetail?id='+item.objectId">{{item.objectName}}</a>)的评论中@了您</span>
                                <span v-else-if="item.notifyType ==9 && item.objectType ==3">在(<a target="_blank" :href="'http://www.renrendonghua.com/activities/matchs/detail?id='+item.objectId">{{item.objectName}}</a>)的评论中@了您</span>

                              <!--  9无悬赏，10，悬赏
                              <span v-else-if="item.notifyType ==9 && item.objectType ==10">在(<a target="_blank" :href="'http://www.renrendonghua.com/videoduo?id='+item.objectId">{{item.objectName}}</a>)的评论中@了您</span>
                              -->
                                <span v-else-if="item.notifyType ==10 && item.objectType ==1">评论并转发了您的作品<a target="_blank" :href="'http://www.renrendonghua.com/worksdetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>
                                <span v-else-if="item.notifyType ==10 && item.objectType ==2">评论并转发了您的文章<a target="_blank" :href="'http://www.renrendonghua.com/column/themedetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>
                                <span v-else-if="item.notifyType ==11 && item.objectType ==3">正在参加<a target="_blank" :href="'http://www.renrendonghua.com/activities/matchs/detail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a>作品征集活动，快进来查看下！</span>
                                <span v-else-if="item.notifyType ==12 && item.objectType ==1">发布了新的作品<a target="_blank" :href="'http://www.renrendonghua.com/worksdetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>
                                <span v-else-if="item.notifyType ==13 && item.objectType ==2">发布了新的文章<a target="_blank" :href="'http://www.renrendonghua.com/column/themedetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>
                                <span v-else-if="item.notifyType ==14 && item.objectType ==12">刚给您添加了一条好友印象：{{item.objectName}}</span>
                                <span v-else-if="item.notifyType ==14 && item.objectType ==13">刚认可了您的认可好友印象：{{item.objectName}}</span>
                                <span v-else-if="item.notifyType ==14 && item.objectType ==14">刚认可了您的个人标签：{{item.objectName}}</span>

                                <span v-else-if="item.notifyType ==15 && item.objectType ==17">邀请您回答<a target="_blank" :href="'http://www.renrendonghua.com/quedetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a></span>
                                <span v-else-if="item.notifyType ==15 && item.objectType ==18">恭喜您在<a target="_blank" :href="'http://www.renrendonghua.com/quedetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a>的回答，被选为最佳答案！</span>
                                <span v-else-if="item.notifyType ==15 && item.objectType ==19">您关注的<a target="_blank" :href="'http://www.renrendonghua.com/quedetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a>有了新的回答</span>
                                <span v-else-if="item.notifyType ==15 && item.objectType ==20">您关注的<a target="_blank" :href="'http://www.renrendonghua.com/quedetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a>有了最佳答案。</span>
                                <span v-else-if="item.notifyType ==15 && item.objectType ==21">您有一笔悬赏奖励新到账，请通过个人中心-个人账户查看收入明细。</span>
                            </li>
                            <li v-if="unReadNotifyCount == 0" class="m-item">暂无通知</li>
                        </ul>
                        <ul class="cont-item" v-if="messageIndex === 1">
                            <li class="m-item" v-for="(item, index) in unReadSystemNotify" :key="index">
                                <span v-if="item.objectType ==1">您的作品<a target="_blank" :href="'http://www.renrendonghua.com/worksdetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a> {{item.notifyContent}}</span>
                                <span v-else-if="item.objectType ==2">您的文章<a target="_blank" :href="'http://www.renrendonghua.com/column/themedetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a> {{item.notifyContent}}</span>
                                <span v-else-if="item.objectType ==4">终于等到你啦，请点击<a target="_blank" :href="'http://www.renrendonghua.com/home/ziliao?userId='+item.notifiedUser">个人资料</a> 添加个性头像和昵称吧</span>
                                <span v-else-if="item.objectType ==5">欢迎回来，点击<a target="_blank" :href="'http://www.renrendonghua.com/home/guanzhu?userId='+item.notifiedUser">我的关注</a> 看看他（她）们的动态吧</span>
                                <span v-else-if="item.objectType ==6">您发表的作品<a target="_blank" :href="'http://www.renrendonghua.com/worksdetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a> 因{{item.notifyContent}}原因被举报，请在3个工作日内进行处理，逾期视为违规处理。</span>
                                <span v-else-if="item.objectType ==7">您发表的文章<a target="_blank" :href="'http://www.renrendonghua.com/column/themedetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a> 因{{item.notifyContent}}原因被举报，请在3个工作日内进行处理，逾期视为违规处理。</span>
                                <span v-else-if="item.objectType ==15 && item.materialSort == 1">您的模型素材<a target="_blank" :href="'http://www.renrendonghua.com/modeldetail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a> {{item.notifyContent}}</span>
                                <span v-else-if="item.objectType ==15 && item.materialSort == 2">您的音效素材<a target="_blank" :href="'http://www.renrendonghua.com/audio/detail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a> {{item.notifyContent}}</span>
                                <span v-else-if="item.objectType ==15 && item.materialSort == 3">您的动作素材<a target="_blank" :href="'http://www.renrendonghua.com/action/detail?id='+item.objectId+'&plate='+item.belongSection">{{item.objectName}}</a> {{item.notifyContent}}</span>
                                <span v-else-if="item.objectType ==16">您收到了<router-link target="_blank" :to="{path:'/home', query: {userId:item.objectId}}">{{item.objectName}}</router-link>的好友申请，<a target="_blank" :href="'http://www.renrendonghua.com/home/haoyou?showIndex=1&userId='+item.notifiedUser">快去看看吧 </a></span>
                                <span v-else-if="item.objectType ==22">亲爱的人人动画网用户，你好，您获得<a target="_blank" :href="'http://www.renrendonghua.com/filmdetail?id='+secId">《中华上下五千年》</a>历史动画剧集免费限时观看权限，赶快进入人人动画网放映厅观看吧！</span>

                              <span v-else>{{item.notifyContent}}</span>
                            </li>
                            <li v-if="unReadSystemNotifyCount == 0" class="m-item">暂无消息</li>
                        </ul>
                        <div class="to-all" v-if="unReadCount > 0">
                            <a target="_blank" href="http://i.renrendonghua.com/message/mine">查看全部</a>
                        </div>
                    </div>
                </div>
            </a>
            <!--<a href="/chatroom" class="btn messages-btn only-pc-show" title="聊天">
                <img class="icon" :src="require('@/assets/images/head_btn_chat.png')" alt="">
                <span class="mess-count" v-if="messageCount!=0">{{messageCount}}</span>
            </a>-->
            <el-dropdown class="user-list">
                <span class="el-dropdown-link">
                  <a href="javascript:;" class="btn">
                    <div class="icon">
                      <img class="user-img" :src="imgUrl" alt="">
                    </div>
                      <!--            <span class="red-point"></span>-->
                  </a>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>{{userName}}</el-dropdown-item>
                    <router-link :to="{path:'/home', query: {userId:userId}}" target="_blank" class="only-pc-show">
                        <el-dropdown-item divided>个人主页</el-dropdown-item>
                    </router-link>


                  <a href="http://i.renrendonghua.com" target="_blank" v-if="plateType == 0" class="only-pc-show"><el-dropdown-item>个人中心</el-dropdown-item></a>
                    <a :href="'http://i.renrendonghua.com?belongSection='+plateType" target="_blank" class="only-pc-show" v-else><el-dropdown-item>个人中心</el-dropdown-item></a>


                  <a href="http://p.renrendonghua.com" target="_blank" class="only-pc-show"><el-dropdown-item>工作台</el-dropdown-item></a>
                  <a href="http://admin.renrendonghua.com" target="_blank" v-if="isAdmin" class="only-pc-show"><el-dropdown-item>管理后台</el-dropdown-item></a>
                  <a href="http://databoard.renrendonghua.com" target="_blank" v-if="isAdmin" class="only-pc-show"><el-dropdown-item>数据看板</el-dropdown-item></a>
                  <router-link :to="'/home/ziliao?userId=' + userId" target="_blank"><el-dropdown-item>个人资料</el-dropdown-item></router-link>
                    <router-link class="only-pc-show" :to="'/home/haoyou?userId=' + userId" target="_blank"><el-dropdown-item>好友</el-dropdown-item></router-link>
                    <router-link to="/setting" target="_blank"><el-dropdown-item>设置</el-dropdown-item></router-link>
                    <el-dropdown-item divided @click.native="logOut()">退出</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>

        <div class="rig-btns" v-if="!isLogin">
            <div class="btn only-phone-show">
              <img class="icon" :src="require('@/assets/images/side_icon_01.png')" @click="dialogQRCodes = true" alt="">
            </div>
            <router-link :to="{path:callbackurl}" class="login">登录/注册</router-link>
            <!--            <router-link :to="{path:callBackRegUrl}" class="register">注册</router-link>-->
        </div>
        <!-- PC端展示中间的导航 -->
        <div class="center-navmenu" v-if="showMenuNav">
            <!-- 新首页 -->
            <!--板块 ： nv：动画短片 1    nt：传统文化 2     na：动画制作 3  plate-->
            <el-menu v-if="plateType == '1' "
                     :default-active="$route.fullPath"
                     class="el-menu-center"
                     text-color="#fff"
                     active-text-color="#fff"
                     mode="horizontal"
            >
                <el-menu-item index="/nAnimatedVideo?plate=1">
                    <a title="动画短片" href="http://www.renrendonghua.com/nAnimatedVideo?plate=1">动画短片</a>
                </el-menu-item>
                <el-menu-item index="/productionList?plate=1&choicenessType=1">
                    <a title="经典动画" href="http://www.renrendonghua.com/productionList?plate=1&choicenessType=1">经典动画</a>
                </el-menu-item>
                <el-menu-item index="/productionList?plate=1&choicenessType=2">
                    <a title="国内动画" href="http://www.renrendonghua.com/productionList?plate=1&choicenessType=2">国内动画</a>
                </el-menu-item>
                <el-menu-item index="/productionList?plate=1&choicenessType=3">
                    <a title="传统文化动画" href="http://www.renrendonghua.com/productionList?plate=1&choicenessType=3">传统文化动画</a>
                </el-menu-item>
            </el-menu>
            <el-menu v-if="plateType == '2'"
                    :default-active="$route.path"
                    class="el-menu-center"
                    text-color="#fff"
                    active-text-color="#fff"
                    mode="horizontal"
            >
                <el-menu-item index="/nTradition">
                    <a title="传统文化" href="http://www.renrendonghua.com/nTradition?plate=2">传统文化</a>
                </el-menu-item>
                <el-menu-item index="/storyList">
                    <a title="故事汇" href="http://www.renrendonghua.com/storyList?plate=2">故事汇</a>
                </el-menu-item>
                <el-menu-item index="/course">
                    <a href="/course?plate=2">直 播</a>
                </el-menu-item>
                <!--<el-menu-item index="/course" @click="reloadPage('/course?plate=2')">直 播</el-menu-item>-->

                <el-menu-item index="/activities/collect">
                    <a title="活 动" href="http://www.renrendonghua.com/activities/collect?plate=2">活 动</a>
                </el-menu-item>

               <!-- <el-submenu index="/activities">
                    <template slot="title"><router-link to="/activities/collect?plate=2">活 动</router-link></template>
                    <el-menu-item index="/activities/collect?plate=2">日常活动</el-menu-item>
                    <el-menu-item index="/activities/matchs?plate=2">大赛活动</el-menu-item>
                </el-submenu>-->

            </el-menu>
            <el-menu v-if="plateType == '3'"
                     :default-active="$route.path"
                     class="el-menu-center"
                     text-color="#fff"
                     active-text-color="#fff"
                     mode="horizontal"
            >
                <el-menu-item index="/nAnimateMake">
                    <a title="动画制作"  href="http://www.renrendonghua.com/nAnimateMake?plate=3">动画制作</a>
                </el-menu-item>
                <el-menu-item index="/productionList">
                    <a title="作 品" href="http://www.renrendonghua.com/productionList?plate=3">作 品</a>
                </el-menu-item>
                <el-menu-item index="/gquestions">
                    <a title="问 答" href="http://www.renrendonghua.com/gquestions?plate=3">问 答</a>
                </el-menu-item>
                <el-menu-item index="/ncolumnList">
                    <a title="专 栏" href="http://www.renrendonghua.com/ncolumnList?plate=3">专 栏</a>
                </el-menu-item>
                <el-menu-item index="/activities/matchs">
                    <a title="活 动" href="http://www.renrendonghua.com/activities/matchs?plate=3">活 动</a>
                </el-menu-item>
                <el-menu-item index="/course">
                    <a title="课 程" href="http://www.renrendonghua.com/course?plate=3">课 程</a>
                </el-menu-item>
                <el-menu-item index="/model">
                    <a title="素 材" href="http://www.renrendonghua.com/model?plate=3">素 材</a>
                </el-menu-item>
                <el-menu-item index="/project">
                    <a title="项目大厅" href="http://www.renrendonghua.com/project?plate=3">项目大厅</a>
                </el-menu-item>
            </el-menu>
            <el-menu v-if="plateType == '0' || plateType == '4'"
                     :default-active="$route.path"
                     class="el-menu-center"
                     text-color="#fff"
                     active-text-color="#fff"
                     mode="horizontal"
            >
                <el-menu-item index="/index">
                    <a title="首页" href="http://www.renrendonghua.com/">首页</a>
                </el-menu-item>
                <el-menu-item index="/filmdetail">
                    <a title="放映厅"  :href="'http://www.renrendonghua.com/filmdetail?id='+secId">放映厅</a>
                </el-menu-item>
                <el-submenu index="/nAnimatedVideo">
                    <template slot="title">
                        <a title="动画短片" href="http://www.renrendonghua.com/nAnimatedVideo?plate=1">动画短片</a>
                    </template>
                    <el-menu-item index="/productionList?plate=1&choicenessType=1">
                        <a title="经典动画" href="http://www.renrendonghua.com/productionList?plate=1&choicenessType=1">经典动画</a>
                    </el-menu-item>
                    <el-menu-item index="/productionList?plate=1&choicenessType=2">
                        <a title="国内动画" href="http://www.renrendonghua.com/productionList?plate=1&choicenessType=2">国内动画</a>
                    </el-menu-item>
                    <el-menu-item index="/productionList?plate=1&choicenessType=3">
                        <a title="传统文化动画"  href="http://www.renrendonghua.com/productionList?plate=1&choicenessType=3">传统文化动画</a>
                    </el-menu-item>
                </el-submenu>
                <el-submenu index="/nTradition?plate=2">
                    <template slot="title">
                        <a title="传统文化" href="http://www.renrendonghua.com/nTradition?plate=2">传统文化</a>
                    </template>
                    <el-menu-item index="/storyList?plate=2">
                        <a title="故事汇" href="http://www.renrendonghua.com/storyList?plate=2">故事汇</a>
                    </el-menu-item>
                    <el-menu-item index="/course">
                        <a href="/course?plate=2">直 播</a>
                    </el-menu-item>
                    <el-menu-item index="/activities/collect?plate=2">
                        <a title="活 动" href="http://www.renrendonghua.com/activities/collect?plate=2">活 动</a>
                    </el-menu-item>
                </el-submenu>
                <el-submenu index="/nAnimateMake">
                    <template slot="title">
                        <a title="动画制作" href="http://www.renrendonghua.com/nAnimateMake?plate=3">动画制作</a>
                    </template>
                    <el-menu-item index="/productionList">
                        <a title="作 品" href="http://www.renrendonghua.com/productionList?plate=3">作 品</a>
                    </el-menu-item>
                    <el-menu-item index="/gquestions">
                        <a title="问 答" href="http://www.renrendonghua.com/gquestions?plate=3">问 答</a>
                    </el-menu-item>
                    <el-menu-item index="/ncolumnList">
                        <a title="专 栏" href="http://www.renrendonghua.com/ncolumnList?plate=3">专 栏</a>
                    </el-menu-item>
                    <el-menu-item index="/activities/matchs">
                        <a title="活 动" href="http://www.renrendonghua.com/activities/matchs?plate=3">活 动</a>
                    </el-menu-item>
                    <el-menu-item index="/course">
                        <a title="课 程" href="http://www.renrendonghua.com/course?plate=3">课 程</a>
                    </el-menu-item>
                    <el-menu-item index="/model">
                        <a title="素 材"  href="http://www.renrendonghua.com/model?plate=3">素 材</a>
                    </el-menu-item>
                    <el-menu-item index="/project">
                        <a title="项目大厅" href="http://www.renrendonghua.com/project?plate=3">项目大厅</a>
                    </el-menu-item>
                </el-submenu>
                <el-menu-item index="/meathuman">
                    <a title="虚拟数字人" href="http://www.renrendonghua.com/meathuman">虚拟数字人</a>
                </el-menu-item>
                <!-- <el-menu-item index="/nAnimatedVideo">
                    <a href="/nAnimatedVideo?plate=1">动画短片</a>
                </el-menu-item>
                <el-menu-item index="/nTradition">
                    <a href="/nTradition?plate=2">传统文化</a>
                </el-menu-item>
                <el-menu-item index="/nAnimateMake">
                    <a href="/nAnimateMake?plate=3">动画制作</a>
                </el-menu-item> -->
            </el-menu>

           <!-- <el-menu v-else
                    :default-active="$route.path"
                    class="el-menu-center"
                    text-color="#fff"
                    active-text-color="#fff"
                    mode="horizontal"
                    :router="true"
            >
                <el-menu-item index="/"  @click="reloadPage('/')">首 页111</el-menu-item>
                <el-menu-item index="/works" @click="reloadPage('/works')">作 品</el-menu-item>
                <el-menu-item index="/storypart">故事汇</el-menu-item>

                &lt;!&ndash; <el-submenu index="/film"> &ndash;&gt;
                    &lt;!&ndash; <template slot="title"><router-link to="/filmlist?num=1">放映厅</router-link></template> &ndash;&gt;
                    <el-menu-item index="/filmlist" @click="reloadPage('/filmlist')">放映厅</el-menu-item>
                &lt;!&ndash; </el-submenu> &ndash;&gt;

                <el-menu-item index="/gquestions" @click="reloadPage('/gquestions')">问 答</el-menu-item>
                <el-menu-item index="/columnall">专 栏</el-menu-item>
                <el-submenu index="/activities">
                    <template slot="title"><router-link to="/activities/collect">活 动</router-link></template>
                    <el-menu-item index="/activities/collect">日常活动</el-menu-item>
                    <el-menu-item index="/activities/matchs">大赛活动</el-menu-item>
                </el-submenu>
                <el-menu-item index="/course" @click="reloadPage('/course')">课 程</el-menu-item>
                <el-menu-item index="/model" @click="reloadPage('/model')">素 材</el-menu-item>
                <el-menu-item index="/project" @click="reloadPage('/project')">项目大厅</el-menu-item>
            </el-menu>-->
        </div>



        <!-- 移动端展示的侧边栏导航 -->
        <transition name="g-slide-nav">
            <div class="mobile-side-navmenu" v-if="showSideNav">
                <!-- <el-menu
                        :default-active="$route.path"
                        class="el-menu-side"
                        :unique-opened="true"
                        :router="true"
                >
                    <el-menu-item index="/index">
                        <i class="el-icon-s-home"></i>
                        首页
                    </el-menu-item>
                    <el-menu-item index="/works">
                        <i class="el-icon-tickets"></i>
                        作品
                    </el-menu-item>
                    <el-menu-item index="/storypart">
                        <i class="el-icon-document-copy"></i>
                        故事汇
                    </el-menu-item> -->

                    <!-- 放映厅多个 -->
                    <!-- <el-submenu index="/film">
                        <template slot="title">
                            <i class="el-icon-wind-power"></i>
                            <router-link to="/filmlist?num=1" class="add-link">放映厅</router-link>
                        </template>
                        <el-menu-item index="/filmlist?num=1">第一放映厅</el-menu-item>
                    </el-submenu> -->
                    <!-- 放映厅单个 -->
                    <!-- <el-menu-item index="/filmlist">
                        <i class="el-icon-wind-power"></i>
                        放映厅
                    </el-menu-item>

                    <el-menu-item index="/gquestions">
                        <i class="el-icon-question"></i>
                        问答
                    </el-menu-item>
                    <el-menu-item index="/columnall">
                        <i class="el-icon-present"></i>
                        专栏
                    </el-menu-item>
                    <el-submenu index="/activities">
                        <template slot="title">
                            <i class="el-icon-wind-power"></i>
                            <router-link to="/activities/collect" class="add-link">活动</router-link>
                        </template>
                        <el-menu-item index="/activities/collect">日常活动</el-menu-item>
                        <el-menu-item index="/activities/matchs">大赛活动</el-menu-item>
                    </el-submenu>
                    <el-menu-item index="/course">
                        <i class="el-icon-notebook-2"></i>
                        课程
                    </el-menu-item>
                    <el-menu-item index="/model">
                        <i class="el-icon-data-analysis"></i>
                        素材
                    </el-menu-item>
                   <el-menu-item index="/project">
                       <i class="el-icon-s-ticket"></i>
                       项目大厅
                   </el-menu-item>
                </el-menu> -->


                <el-menu
                    v-if="plateType == '1' "
                    :default-active="$route.fullPath"
                    class="el-menu-side"
                    :unique-opened="true"
                >
                    <el-menu-item index="/nAnimatedVideo?plate=1">
                        <a title="动画短片" href="http://www.renrendonghua.com/nAnimatedVideo?plate=1">动画短片</a>
                    </el-menu-item>
                    <el-menu-item index="/productionList?plate=1&choicenessType=1">
                        <a title="经典动画" href="http://www.renrendonghua.com/productionList?plate=1&choicenessType=1">经典动画</a>
                    </el-menu-item>
                    <el-menu-item index="/productionList?plate=1&choicenessType=2">
                        <a title="国内动画" href="http://www.renrendonghua.com/productionList?plate=1&choicenessType=2">国内动画</a>
                    </el-menu-item>
                    <el-menu-item index="/productionList?plate=1&choicenessType=3">
                        <a title="传统文化动画" href="http://www.renrendonghua.com/productionList?plate=1&choicenessType=3">传统文化动画</a>
                    </el-menu-item>
                </el-menu>
                <el-menu
                    v-if="plateType == '2'"
                    :default-active="$route.path"
                    class="el-menu-side"
                    :unique-opened="true"
                >
                    <el-menu-item index="/nTradition">
                        <a title="传统文化" href="http://www.renrendonghua.com/nTradition?plate=2">传统文化</a>
                    </el-menu-item>
                    <el-menu-item index="/storyList">
                        <a title="故事汇" href="http://www.renrendonghua.com/storyList?plate=2">故事汇</a>
                    </el-menu-item>
                    <!--<el-menu-item index="/course" @click="reloadPage('/course?plate=2')">直 播</el-menu-item>-->

                    <el-menu-item index="/activities/collect">
                        <a title="活 动" href="http://www.renrendonghua.com/activities/collect?plate=2">活 动</a>
                    </el-menu-item>

                <!-- <el-submenu index="/activities">
                        <template slot="title"><router-link to="/activities/collect?plate=2">活 动</router-link></template>
                        <el-menu-item index="/activities/collect?plate=2">日常活动</el-menu-item>
                        <el-menu-item index="/activities/matchs?plate=2">大赛活动</el-menu-item>
                    </el-submenu>-->

                </el-menu>
                <el-menu
                    v-if="plateType == '3'"
                    :default-active="$route.path"
                    class="el-menu-side"
                    :unique-opened="true"
                >
                    <el-menu-item index="/nAnimateMake">
                        <a title="动画制作"  href="http://www.renrendonghua.com/nAnimateMake?plate=3">动画制作</a>
                    </el-menu-item>
                    <el-menu-item index="/productionList">
                        <a title="作 品" href="http://www.renrendonghua.com/productionList?plate=3">作 品</a>
                    </el-menu-item>
                    <el-menu-item index="/gquestions">
                        <a title="问 答" href="http://www.renrendonghua.com/gquestions?plate=3">问 答</a>
                    </el-menu-item>
                    <el-menu-item index="/ncolumnList">
                        <a title="专 栏" href="http://www.renrendonghua.com/ncolumnList?plate=3">专 栏</a>
                    </el-menu-item>
                    <el-menu-item index="/activities/matchs">
                        <a title="活 动" href="http://www.renrendonghua.com/activities/matchs?plate=3">活 动</a>
                    </el-menu-item>
                    <el-menu-item index="/course">
                        <a title="课 程" href="http://www.renrendonghua.com/course?plate=3">课 程</a>
                    </el-menu-item>
                    <el-menu-item index="/model">
                        <a title="素 材" href="http://www.renrendonghua.com/model?plate=3">素 材</a>
                    </el-menu-item>
                    <el-menu-item index="/project">
                        <a title="项目大厅" href="http://www.renrendonghua.com/project?plate=3">项目大厅</a>
                    </el-menu-item>
                </el-menu>

                <el-menu
                    v-if="plateType == '0' || plateType == '4'"
                    :default-active="$route.path"
                    class="el-menu-side"
                    :unique-opened="true"
                >
                    <el-menu-item index="/index">
                        <a title="首页" href="http://www.renrendonghua.com/">首页</a>
                    </el-menu-item>
                    <el-menu-item index="/filmdetail">
                        <a title="放映厅" :href="'http://www.renrendonghua.com/filmdetail?id='+secId">放映厅</a>
                    </el-menu-item>
                    <el-submenu index="/nAnimatedVideo">
                        <template slot="title">
                            <a title="动画短片" href="http://www.renrendonghua.com/nAnimatedVideo?plate=1">动画短片</a>
                        </template>
                        <el-menu-item index="/productionList?plate=1&choicenessType=1">
                            <a title="经典动画" href="http://www.renrendonghua.com/productionList?plate=1&choicenessType=1">经典动画</a>
                        </el-menu-item>
                        <el-menu-item index="/productionList?plate=1&choicenessType=2">
                            <a title="国内动画" href="http://www.renrendonghua.com/productionList?plate=1&choicenessType=2">国内动画</a>
                        </el-menu-item>
                        <el-menu-item index="/productionList?plate=1&choicenessType=3">
                            <a title="传统文化动画"  href="http://www.renrendonghua.com/productionList?plate=1&choicenessType=3">传统文化动画</a>
                        </el-menu-item>
                    </el-submenu>
                    <el-submenu index="/nTradition?plate=2">
                        <template slot="title">
                            <a title="传统文化" href="http://www.renrendonghua.com/nTradition?plate=2">传统文化</a>
                        </template>
                        <el-menu-item index="/storyList?plate=2">
                            <a title="故事汇" href="http://www.renrendonghua.com/storyList?plate=2">故事汇</a>
                        </el-menu-item>
                        <el-menu-item index="/activities/collect?plate=2">
                            <a title="活 动" href="http://www.renrendonghua.com/activities/collect?plate=2">活 动</a>
                        </el-menu-item>
                    </el-submenu>
                    <el-submenu index="/nAnimateMake">
                        <template slot="title">
                            <a title="动画制作" href="http://www.renrendonghua.com/nAnimateMake?plate=3">动画制作</a>
                        </template>
                        <el-menu-item index="/productionList">
                            <a title="作 品" href="http://www.renrendonghua.com/productionList?plate=3">作 品</a>
                        </el-menu-item>
                        <el-menu-item index="/gquestions">
                            <a title="问 答" href="http://www.renrendonghua.com/gquestions?plate=3">问 答</a>
                        </el-menu-item>
                        <el-menu-item index="/ncolumnList">
                            <a title="专 栏" href="http://www.renrendonghua.com/ncolumnList?plate=3">专 栏</a>
                        </el-menu-item>
                        <el-menu-item index="/activities/matchs">
                            <a title="活 动" href="http://www.renrendonghua.com/activities/matchs?plate=3">活 动</a>
                        </el-menu-item>
                        <el-menu-item index="/course">
                            <a title="课 程" href="http://www.renrendonghua.com/course?plate=3">课 程</a>
                        </el-menu-item>
                        <el-menu-item index="/model">
                            <a title="素 材"  href="http://www.renrendonghua.com/model?plate=3">素 材</a>
                        </el-menu-item>
                        <el-menu-item index="/project">
                            <a title="项目大厅" href="http://www.renrendonghua.com/project?plate=3">项目大厅</a>
                        </el-menu-item>
                    </el-submenu>
                    <el-menu-item index="/meathuman">
                        <a title="虚拟数字人" href="http://www.renrendonghua.com/meathuman">虚拟数字人</a>
                    </el-menu-item>
                    <!-- <el-menu-item index="/nAnimatedVideo">
                        <a href="/nAnimatedVideo?plate=1">动画短片</a>
                    </el-menu-item>
                    <el-menu-item index="/nTradition">
                        <a href="/nTradition?plate=2">传统文化</a>
                    </el-menu-item>
                    <el-menu-item index="/nAnimateMake">
                        <a href="/nAnimateMake?plate=3">动画制作</a>
                    </el-menu-item> -->
                </el-menu>
            </div>
        </transition>


        <!-- 遮罩 -->
        <transition name="g-fade">
            <div class="side-mask" v-if="showSideNav" @click="hideSideNavEvent"></div>
        </transition>
        <!-- 移动端侧边栏导航 触发按钮 -->
        <div class="side-nav-btn" @click="showSideNavEvent">
            <i class="el-icon-menu"></i>
        </div>

        <el-dialog
            class="common-dialog"
            :visible.sync="dialogQRCodes"
            :close-on-click-modal="false"
            :modal-append-to-body="false"
            append-to-body
        >
            <div class="side-qr-list clearfix">
                <div class="qr-item">
                    <img :src="require('@/assets/images/side_qr_01.jpg')" alt="">
                    <p class="tit">观影厅小程序</p>
                </div>
                <div class="qr-item">
                    <img :src="require('@/assets/images/side_qr_04.jpg')" alt="">
                    <p class="tit">人人动画APP</p>
                </div>
                <div class="qr-item">
                    <img :src="require('@/assets/images/side_qr_03.jpg')" alt="">
                    <p class="tit">微信公众号</p>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script type="text/ecmascript-6">
    //import "../../../../static/css/animate.min.css"
    import axios from 'axios';
    import vue from 'vue';

    vue.use(global_)
    import global_ from '@/api/global'

    vue.prototype.$axios = axios;
    import VueCookies from 'vue-cookies'
    import Vue from"vue";

    vue.use(VueCookies);
    export default {
        components: {},
        data() {
            return {
                secId:Number(process.env.VUE_APP_RR_SID),
                userType:0,
                isAdmin:false,
                currentUserInfo:{},//当前登录人
                showSideNav: false,
                showMenuNav: true,
                messageIndex: 0,
                isLogin: false,
                currentRourterPath: '/',
                showChild: false,
                imgUrl: "",
                studioUrl: "",
                userName: "",
                userId: 0,
                loginSuccess: 0,
                sso_sessionid: "",
                callbackurl: "",
                callBackRegUrl: "",
                unReadCount: 0,
                unReadNotify: [],
                unReadNotifyCount:0,
                unReadSystemNotify: [],
                unReadSystemNotifyCount:0,
                messageCount:0,
                tipShow: true,
                user: { //当前用户信息
                    id:null,
                    name: "",
                    equipment: 'browser',
                    browser:"Chrome",
                    browserVersion:"70.0.3538.25",
                    workshop_id: null,
                    activity_id: null,
                    course_id:null,
                    // url: window.location.href,
                    group_type:null,
                    face: '',
                    status:0
                },
                plateType:"",
                dialogQRCodes: false
            }
        },

        // sockets:{
            // connect: function(data) {
            //     //console.log("socket链接成功---------------------------------")
            // },
            // disconnect:function(){
            //     this.$socket.emit('connection',1);
            // },
            // reconnect:function(){
            //     this.$socket.emit('connection',1);
            // },
            // newMsg: function(data) {
            //     console.log(data)
            //     if(window.location.href.indexOf("/chatroom")!=-1){
            //         this.messageCount=0;
            //     }else{
            //         this.messageCount=this.messageCount+1;
            //     }
            //
            // },
            // emitUnreadMessage: function(data) {
            //     if(window.location.href.indexOf("/chatroom")!=-1){
            //         this.messageCount=0;
            //     }else{
            //         this.messageCount=data;
            //     }
            // },

        // },
        watch: {
            $route() {
                //console.log("==================change")
                this.showMenuNav =false
                setTimeout(()=>{this.showMenuNav = true},10)
                // this.$socket.emit('unReadMessage', this.user.id);
                clearTimeout(this.hidetip)
                this.initTip() // 切换路由时发布文章提醒重新打开,一定时间关闭

                this.currentRourterPath = this.$route.path
                this.showSideNav = false
                this.callbackurl = "/login?callback=" + window.location.href;
                this.callBackRegUrl = "/register?callback=" + window.location.href;
            }
        },
        computed: {
            homeScroll() {
                return this.$store.state.app.homeScroll
            }
        },

        mounted() {

            let pType = this.$route.query.plate

            if(pType){
                this.plateType = pType
            }else {
                this.plateType = "0"
            }


            this.initTip() // 初始化时一定时间关闭发布文章提醒

            if (this.$route.params.loginSuccess == 1) {
                this.loginSuccess = this.$route.params.loginSuccess
            }
            this.setPath();
            // this.checkIsLogin();
            this.showLoginSuccess();
            this.studioUrl = "http://i.renrendonghua.com";
            this.callbackurl = "/login?callback=" + window.location.href;
            this.callBackRegUrl = "/register?callback=" + window.location.href;
            window.onbeforeunload = function () {
                let captchaCheck="0"
                if(localStorage.getItem('captchaCheck')!=null){
                    captchaCheck=localStorage.getItem('captchaCheck');
                }
                let storage = window.localStorage;
                storage.clear()
                window.localStorage.setItem('captchaCheck',captchaCheck);
            }
            this.checkIsLogin();
        },
        created() {
            // this.checkIsLogin();
        },
        methods: {
            reloadPage(page){
                window.location.href=page;
            },
            showLoginSuccess: function () {
                let _this = this;
                if (_this.loginSuccess == 1) {
                    _this.$message({
                        message: '登录成功',
                        type: 'success'
                    });

                }
            },
            goStudio() {
                window.location.href = process.env.VUE_APP_STUDIO;
            },


            // initSocket(){
            //     setTimeout(()=>{   //设置延迟执行
            //         this.$socket.emit('login', this.user);
            //         this.$socket.emit('unReadMessage', this.user.id);
            //     },1500);
            //
            // },
            checkIsLogin: function () {
                let _this = this;
                let url = '/api/checkLogin?time=' + new Date().getMilliseconds();
                // if(_this.sso_sessionid!=''){
                //   url=url+"?"+_this.sso_sessionid;
                // }
                //console.log("验证登录状态")
                this.$axios.get(url).then(function (result) {
                    //console.log("验证登录状态 result ========>",result)
                    if (result.data.isLogin && result.data.casFastUserModel != null) {
                        if(result.data.isAdmin==1){
                          _this.isAdmin = true;
                        }else{
                          _this.isAdmin = false;
                        }
                        _this.userType = result.data.userType
                        _this.imgUrl = "http://iss.21teacher.com/avatar/125/" + result.data.casFastUserModel.id + "/0.jpg";
                        _this.isLogin = true;
                        _this.userName = result.data.casFastUserModel.name;
                        _this.userId = result.data.casFastUserModel.id;

                        _this.currentUserInfo=result.data.casFastUserModel
                        _this.user.id=_this.currentUserInfo.id
                        _this.user.name=_this.currentUserInfo.name
                        _this.user.face="http://iss.21teacher.com/avatar/125/"+_this.currentUserInfo.id+"/20.jpg"
                        _this.initSocket();
                        global_.setUserModel(result.data.casFastUserModel);
                        global_.setIsLogin(true)

                        _this.$axios.get("/rrbi/notifications/getMyNotify/" + _this.userId + "?time=" + new Date().getMilliseconds()).then(function (data) {
                           // console.log("getMyNotify======>",data)
                            _this.unReadCount = data.data.response.unReadCount>99?99:data.data.response.unReadCount
                            _this.unReadNotify = data.data.response.unReadNotify
                            _this.unReadNotifyCount = data.data.response.unReadNotify.length
                            _this.unReadSystemNotify = data.data.response.unReadSystemNotify
                            _this.unReadSystemNotifyCount = data.data.response.unReadSystemNotify.length

                        })
                    } else {
                        _this.isLogin = false;
                    }
                    //console.log(_this.imgUrl)
                })
            },
            logOut() {
                let _this = this;
                let url = '/api/logOut?time=' + new Date().getMilliseconds();
                this.$axios.get(url).then(function (result) {
                    // _this.$message({
                    //   message: '退出成功',
                    //   type: 'success'
                    // });
                    if (result.data == "1") {
                        _this.$cookies.remove("userId", "/", '.renrendonghua.com');

                        _this.$cookies.remove("user_id", "/", process.env.VUE_APP_DOMAIN);
                        _this.$cookies.remove("user_name", "/", process.env.VUE_APP_DOMAIN);
                        _this.$cookies.remove("sso_sessionid", "/", process.env.VUE_APP_DOMAIN);
                        _this.$cookies.remove("JSESSIONID", "/", process.env.VUE_APP_DOMAIN);
                        _this.$cookies.remove("sso_sessionid", "/", "www." + process.env.VUE_APP_DOMAIN);
                        global_.setUserModel(null);
                        global_.setIsLogin(false)
                    }
                    window.location.reload();
                })


            },
            setPath() {
                this.currentRourterPath = this.$route.path
            },
            showProductChild() {
                this.showChild = true
            },
            hideProductChild() {
                this.showChild = false
            },
            showSideNavEvent() {
                this.showSideNav = true
            },
            hideSideNavEvent() {
                this.showSideNav = false
            },
            messageEvent(index) {
                this.messageIndex = index
            },
            initTip () {
                this.tipShow = true
                this.autoHideTip()
            },
            hideTip () {
                this.tipShow = false
            },
            autoHideTip () {
                this.hidetip = setTimeout(() => {
                    this.tipShow = false
                }, 3000)
            },
        },
        beforeDestroy () {
            clearTimeout(this.hideTip)
        }
    }
</script>

<style scoped lang="less">
    .el-menu--horizontal{
        .el-menu.el-menu--popup.el-menu--popup-bottom-start{
            .el-menu-item{
                color: @HEADBG !important;
                &.is-active,
                &:hover{
                    color: #e62229 !important;
                }
                a{
                    display: block;
                    &:hover{
                        color: #e62229;
                    }
                }
            }
        }
    }
    .header {
        position: fixed;
        z-index: 1888;
        width: 100%;
        height: @NAVHEIGHT;
        background: @HEADBG;

        .logo-h1 {
            float: left;
            height: @NAVHEIGHT;

            .logo-f {
                display: block;
                height: 100%;

                .logo-img {
                    display: block;
                    height: 100%;
                }
            }
        }

        .rig-btns {
            float: right;

            .btn {
                position: relative;
                float: left;
                margin: 0 8px;
                width: 30px;
                height: @NAVHEIGHT;

                // &:last-child {
                //     margin-right: 0;
                // }

                .icon {
                    overflow: hidden;
                    margin: ((@NAVHEIGHT - 30) / 2) auto 0;
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;

                    .user-img {
                        width: 100%;
                    }
                }
                &.upload-btn{
                    .upload-tips{
                        position: absolute;
                        right: 50%;
                        top: 68px;
                        padding: 5px;
                        margin-right: -70px;
                        width: 140px;
                        text-align: center;
                        word-break: keep-all;
                        color: #fff;
                        font-size: 12px;
                        background: #409eff;
                        border-radius: 5px;
                        &:before{
                            position: absolute;
                            right: 50%;top: -12px;
                            margin-right: -6px;
                            z-index: 5;
                            content: '';
                            display: block;
                            width: 0;
                            height: 0;
                            border: 6px solid;
                            border-color: transparent transparent #409eff transparent;
                        }
                    }
                }

                &.messages-btn {
                    .mess-count {
                        position: absolute;
                        right: 0;
                        top: 10px;
                        display: block;
                        width: 16px;
                        height: 16px;
                        line-height: 16px;
                        color: #e62229;
                        font-size: 12px;
                        text-align: center;
                        background: #fff;
                        border-radius: 50%;
                    }

                    .messages-show {
                        padding-top: 12px;
                        // overflow: hidden;
                        opacity: 0;
                        position: absolute;
                        right: 0;
                        top: @NAVHEIGHT;
                        width: 220px;
                        transform: scale(0);
                        transition: all .2s;
                        &:before{
                            position: absolute;
                            right: 10px;top: 1px;
                            z-index: 5;
                            content: '';
                            display: block;
                            width: 0;
                            height: 0;
                            border: 6px solid;
                            border-color: transparent transparent #eee transparent;

                        }
                        &:after{
                            position: absolute;
                            right: 10px;top: 3px;
                            z-index: 5;
                            content: '';
                            display: block;
                            width: 0;
                            height: 0;
                            border: 6px solid;
                            border-color: transparent transparent #fff transparent;

                        }

                        .tabs-tit {
                            overflow: hidden;
                            position: relative;
                            border-bottom: 1px solid #ebebeb;
                            background: #fff;
                            box-shadow: 0 5px 5px #999;
                            border-top: 1px solid #eee;
                            border-radius: 5px 5px 0 0;

                            &:after {
                                position: absolute;
                                left: 50%;
                                top: 8px;
                                content: '';
                                display: block;
                                width: 1px;
                                height: 24px;
                                background: #ebebeb;
                            }

                            li {
                                float: left;
                                width: 50%;
                                line-height: 40px;
                                font-size: 16px;
                                text-align: center;

                                &.active {
                                    color: #409eff;
                                }
                            }
                        }

                        .tabs-content {
                            position: relative;
                            z-index: 2;
                            padding: 0 10px;
                            cursor: auto;
                            background: #fff;
                            box-shadow: 0 5px 10px #999;
                            border-radius: 0 0 5px 5px;

                            .cont-item {
                                .m-item {
                                    padding: 10px 0;
                                    font-size: 14px;
                                    border-bottom: 1px solid #eee;

                                    a {
                                        color: #409eff;
                                    }
                                }
                            }
                        }

                        .to-all {
                            position: relative;
                            display: block;
                            line-height: 40px;
                            text-align: center;
                            background: #fff;

                            a {
                                font-size: 14px;
                            }
                        }
                    }

                    &:hover {
                        .messages-show {
                            opacity: 1;
                            transform: scale(1);
                        }
                    }
                }

                .red-point {
                    position: absolute;
                    right: 0;
                    top: 10px;
                    display: block;
                    width: 8px;
                    height: 8px;
                    background: #ff0000;
                    border-radius: 50%;
                }
            }

            .user-list,
            .upload-art {
                float: left;
                margin: 0 8px;
            }

            .login,
            .register {
                float: left;
                margin: 0 8px;
                line-height: @NAVHEIGHT;
                font-size: 12px;
                color: #fff;
            }

            .register {
                position: relative;
                margin-right: 0;

                &:after {
                    position: absolute;
                    left: -8px;
                    top: (@NAVHEIGHT - 10) / 2;
                    content: '';
                    display: block;
                    width: 1px;
                    height: 10px;
                    background: #fff;
                }
            }
        }

        .center-navmenu {
            position: absolute;
            left: 50%;
            margin-left: -360px;
            width: 720px;

            .el-menu-center {
                height: @NAVHEIGHT;
                background: none;

                &.el-menu.el-menu--horizontal{
                    border-bottom: none !important;
                }

                .el-menu-item {
                    margin: 0;
                    padding: 0 22px;
                    height: @NAVHEIGHT;
                    line-height: @NAVHEIGHT;
                    font-size: 16px;
                    border: none !important;
                    &:focus {
                        background:  @HEADBG !important;
                    }
                    &:hover,
                    &.is-active{
                        background: #e62229 !important;
                    }
                    a{
                        display: block;
                    }
                }

                /deep/ .el-submenu {
                    margin: 0;
                    &.is-active{
                        background: #e62229;
                    }
                    .el-submenu__title {
                        padding: 0 22px;
                        height: @NAVHEIGHT !important;
                        line-height: @NAVHEIGHT !important;
                        font-size: 16px;
                        border: none !important;
                        &:hover{
                            background: #e62229;
                        }
                        i.el-submenu__icon-arrow.el-icon-arrow-down,
                        a{
                            display: inline-block;
                            color: #fff;
                        }
                    }
                }
            }
        }

        .mobile-side-navmenu {
            position: fixed;
            z-index: 100000;
            left: 0;
            top: 0;
            width: 200px;
            height: 100vh;
            background: #404e67;

            .el-menu-side {
                position: relative;
                z-index: 200;
                width: 100%;
                height: 100%;
                background: #404e67;
                border-right: none;
                // 无子集
                /deep/ .el-menu-item {
                    color: #fff;

                    i {
                        color: inherit !important;
                    }

                    &.is-active {
                        background: #38445a;
                        color: #409eff;
                    }

                    &:hover,
                    &:focus {
                        background: #38445a;
                    }
                    a{
                        display: block;
                    }
                }

                // 有子集
                /deep/ .el-submenu {
                    // &.is-opened{}
                    .el-submenu__title {
                        color: #fff;

                        i {
                            color: inherit !important;
                        }

                        .add-link{
                            margin-left: 5px;
                            color: #fff;
                        }

                        &:hover {
                            background: #38445a;
                        }
                    }

                    .el-menu {
                        background: none;

                        .el-menu-item-group {
                            .el-menu-item-group__title {
                                padding: 0;
                            }
                        }
                    }
                }
                a{
                    color: #fff;
                }
            }
        }

        .side-mask {
            position: fixed;
            z-index: 99999;
            left: 0;
            top: 0;
            width: 100vw;
            height: 100vh;
            background: rgba(0, 0, 0, .5);
        }

        .side-nav-btn {
            position: fixed;
            left: 0;
            top: 50%;
            margin-top: -22px;
            width: 44px;
            height: 44px;
            line-height: 44px;
            text-align: center;
            background: #fff;
            border-radius: 0 10px 10px 0;
            box-shadow: 0 0 5px #999;
        }
    }

    // 手机
    @media screen and (max-width: 750px) {
        .header {
            padding: 0 5px !important;
            .rig-btns{
                .btn{
                    margin: 0;
                }
            }
        }
    }

    // pad
    @media screen and (min-width: 751px) {
        .header {
            padding: 0 50px;
        }
    }

    // 1249px以内(包括上面的手机和pad尺寸) 顶部中间的导航隐藏，以侧边栏形式展开
    @media screen and (max-width: 999px) {
        .header {
            .center-navmenu {
                display: none;
            }

            .mobile-side-navmenu {
                display: block;
            }

            .side-nav-btn {
                display: block;
            }
        }
    }

    // PC
    @media screen and (min-width: 1000px) {
        .header {
            padding: 0 100px;

            .center-navmenu {
                display: block;
            }

            .mobile-side-navmenu {
                display: none;
            }

            .side-nav-btn {
                display: none;
            }
        }
    }

    @media screen and (max-width: 1300px) {
        .header{
            padding: 0 30px;
        }
    }

    // 渐隐渐现
    .g-fade-enter,
    .g-fade-leave-to {
        opacity: 0
    }

    .g-fade-enter-active,
    .g-fade-leave-active {
        transition: opacity .3s;
    }

    // 移动导航
    .g-slide-nav-enter,
    .g-slide-nav-leave-to {
        transform: translateX(-200px);
    }

    .g-slide-nav-enter-active,
    .g-slide-nav-leave-active {
        transition: transform .3s;
    }
    .side-qr-list {
        margin-top: 10px;
        .qr-item {
            float: left;
            width: 50%;
            img {
                display: block;
                width: 90%;
                margin: 0 auto;
            }
            .tit {
                margin-top: 5px;
                text-align: center;
            }
        }
    }
</style>
